// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_UncancelResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/orders/uncancel/{id}
 *
 * Returns the order id and its new status after uncancellation.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_UncancelResponseDados {
order_id: number
status: string
}

export type Orders_UncancelResponse = ApiResponse<Orders_UncancelResponseDados>;

registerResponseContract('Orders_UncancelResponse', {
  order_id: { type: 'number',  required: true },
  status:   { type: 'string',  required: true },
})
